import React, { useEffect, useState } from 'react'
import {Box, Card, CardActions, CardContent, Button, Typography} from '@material-ui/core';
import './DeletarTema.css';
import { useHistory, useParams } from 'react-router-dom';
import useLocalStorage from 'react-use-localstorage';
import { buscaId, deleteId } from '../../../services/Service';
import Tema from '../../../models/Tema';
import { useSelector } from 'react-redux';
import { UserState } from '../../../store/tokens/keysRedux';
import { toast } from 'react-toastify';


function DeletarTema() {
  let history = useHistory();
  const { id } = useParams<{id: string}>();
  const token = useSelector<UserState, UserState["tokens"]>(
    (state) => state.tokens
  ) 

  const [tema, setTema] = useState<Tema>()

  useEffect(() => {
      if (token === "") {
          alert("Você precisa estar logado")
           toast.success('Você precisa estar logado', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    theme: "colored",
                    progress: undefined,
                });
          history.push("/logar")
  
      }
  }, [token])

  useEffect(() =>{
      if(id !== ''){
          findById(id)
      }
  }, [id])

  async function findById(id: string) {
      buscaId(`/temas/${id}`, setTema, {
          headers: {
            'Authorization': token
          }
        })
      }

      function sim() {
        try{
          history.push('/tema')
          deleteId(`/temas/${id}`, {
            headers: {
              'Authorization': token
            }
          });
          toast.success('Tema deletado com sucesso', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    theme: "colored",
                    progress: undefined,
                });
        }catch(error){
          toast.error('Error!! ao deletetar', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    theme: "colored",
                    progress: undefined,
                });
        }
      }
      
        function nao() {
          history.push('/tema')
        }
          
  return (
    <>
       <Box   className="largura" m={2}>
        <Card className="back-listapostagem" variant="outlined">
          <CardContent>
            <Box justifyContent="center">
              <Typography className="text-listagempostagem" color="textSecondary" gutterBottom>
                Deseja deletar o Tema:
              </Typography>
              <Typography className="titulo-listagempostagem"  color="textSecondary">
                {tema?.descricao}
              </Typography>
            </Box>
          </CardContent>
          <CardActions>
            <Box display="flex" justifyContent="start" ml={1.0} mb={2} >
              <Box mx={2}>
                <Button onClick={sim} variant="contained" className="marginLeft back-button" size='large' color="primary">
                  Sim
                </Button>
              </Box>
              <Box mx={2}>
                <Button  className="btnCancelar"onClick={nao} variant="contained" size='large' color="secondary">
                  Não
                </Button>
              </Box>
            </Box>
          </CardActions>
        </Card>
      </Box>
    </>
  );
}
export default DeletarTema;